import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { Link, Redirect } from 'react-router-dom';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import { auth } from '../firebase';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const styles = theme => ({
    root: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
    },
    card: {
        width: '20rem',
        height: '50%',
        top: '25%',
        margin: '0 auto',
        position: 'relative',
        textAlign: 'center',
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    main: {
        marginTop: '10%',
        height: '80%',
        width: '100%'
    },
    loader: {
        width: '5rem',
        height: '40%',
        top: '30%',
        margin: '0 auto',
        position: 'relative',
    },
});

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            loggingIn: false,
            email: '',
            password: '',
        };
    }

    signin = () => {
        if(this.state.email === '' || this.state.password === '') {
            /* Push.create("KBAAZ", {
                body: "Please fillout all fields!!!",
                logo: './k-logo.png',
                timeout: 4000,
                onClick: function () {
                    window.focus();
                    this.close();
                }
            }); */
            toast.warn('Please fill out all fields!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {

            this.setState({
                loggingIn: true,
            });

            auth.signInWithEmailAndPassword(this.state.email, this.state.password)
                .then(() => {
                    /* Push.create("KBAAZ", {
                        body: "Login successful!!!",
                        logo: './k-logo.png',
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    }); */
                    toast.success('Login successful!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });

                    setTimeout(this.completeLogin, 300);     
                })
                .catch(() => {
                    /* Push.create("KBAAZ", {
                        body: "Wrong email or password!!!",
                        logo: './k-logo.png',
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    }); */
                    toast.error('Wrong email-id or password!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    this.setState({loggingIn: false});
                });
        }
    }

    completeLogin = () => {
        this.setState({
            redirect: true,
            loggingIn: false,
        });
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    render() {
        const { classes } = this.props;

        if(this.state.redirect) {
            return(
                <Redirect to='/' />
            )
        }

        if(this.state.loggingIn) {
            return(
                <div className={classes.root}>
                    <div className={classes.loader}>
                        <CircularProgress/>
                    </div>
                </div>
            )
        }

        return (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <div className={classes.main}>
                        <Typography style={{ paddingBottom: '10px'}} gutterBottom={false} color="primary" variant="title">WELCOME TO KBAAZ</Typography>
                        <TextField
                            onChange={this.handleChange('email')}
                            style={{ paddingBottom: '10px', width: '80%' }}
                            label="Email"
                        />
                        <TextField
                            onChange={this.handleChange('password')}
                            style={{ paddingBottom: '30px', width: '80%' }}
                            type="password"
                            label="Password"
                        />
                        <br />
                        <Button onClick={this.signin} color="primary" variant="raised">
                            Login
                        </Button>
                        <Typography style={{ paddingTop: '25px' }} gutterBottom={false} variant="caption">Not Registered?<Link to="/register">Create an Account</Link></Typography>
                        <Typography style={{ paddingTop: '25px' }} gutterBottom={false} variant="caption">Not Registered?<Link to="/reset">Forgot Password? Click here</Link></Typography>
                    </div>
                </Card>
            </div>
        );
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js